import { Enum } from 'enumify';

export default class UserType extends Enum {}
UserType.initEnum([
  'PATIENT',
  'THERAPIST',
  'CAREGIVER',
]);



// WEBPACK FOOTER //
// ./src/routes/user/UserType.js